import { useNavigate } from "react-router-dom";
import { Button } from "@ficatranquilo/contabilidade.com-ui";
import { PublicPage } from "../Common/PublicPage";
import useLogoutApp from "./useLogoutApp";

// Conta que existe no Auth0 mas não no OneWork: o back recusa tudo com
// USER_NOT_REGISTERED até ela entrar por um convite ou por um cadastro de empresa.
export default function AccountNotRegistered() {
  const navigate = useNavigate();
  const logoutApp = useLogoutApp();

  return (
    <PublicPage
      title="Sua conta não está cadastrada no OneWork"
      description="Se você é colaborador, peça ao administrador da empresa um link de convite. Se quer usar o OneWork na sua empresa, faça o cadastro dela."
      actions={
        <>
          <Button $text="Sair" $variant="outline" $action={logoutApp} />
          <Button $text="Cadastrar minha empresa" $variant="primary" $action={() => navigate("/sign-up")} />
        </>
      }
    />
  );
}
